import * as React from 'react'
export const CustomCounterCustomer = ({ time }) => {
    const [minute, setMinute] = React.useState(0);
    const [second, setSecond] = React.useState(0);
    React.useEffect(() => {
        if (time > 60) {
            setMinute(Math.floor(time / 60));
            setSecond(time - Math.floor(time / 60) * 60);
        } else {
            setMinute(0);
            setSecond(time);
        }
    }, [time]);

    return (
        <>
            ({time === 60 ? "01" : (minute < 10 ? "0" + minute : minute)} : {second === 60 ? "00" : (second < 10 ? "0" + second : second)})
        </>
    );
}